import { reportOutageNow } from '../../data/system-status.js';

/** Aynı sekmede son yenilemenin zamanı; döngü koruması için oturum deposunda tutulur. */
export const CHUNK_RELOAD_KEY = 'dentos-parca-yenileme';
export const CHUNK_RELOAD_WINDOW_MS = 30_000;

interface Deps {
  now: () => number;
  reload: () => void;
  storage: Pick<Storage, 'getItem' | 'setItem'> | null;
}

/** Gizli pencerede ya da kapalı site verisinde depo erişimi fırlatır; o zaman depo yoktur. */
function sessionStore(): Deps['storage'] {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

const defaults = (): Deps => ({
  now: Date.now,
  reload: () => window.location.reload(),
  storage: sessionStore(),
});

function lastReload(storage: Deps['storage']): number {
  try {
    return Number(storage?.getItem(CHUNK_RELOAD_KEY) ?? 0) || 0;
  } catch {
    return 0;
  }
}

/**
 * Tembel bir parça yüklenemedi (`vite:preloadError`). Güncellemeden önce açılmış bir sekmenin
 * aradığı dosya artık yayında yoksa en olası sebep yeni sürümdür: sayfa BİR KEZ yeni sürümle
 * yeniden yüklenir. 30 sn içinde tekrarlarsa sebep sürüm değildir (ağ ya da sunucu): döngüye
 * girilmez, olay engellenmez (mevcut "Sayfa yüklenemedi" işleyicileri çalışır) ve kesinti
 * katmanı açılır.
 */
export function handlePreloadError(event: Event, deps: Deps = defaults()): void {
  // Çevrimdışıyken yenilemek sekmeyi tarayıcının hata sayfasına düşürürdü: sebep sürüm değil ağdır.
  const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
  if (offline || deps.now() - lastReload(deps.storage) < CHUNK_RELOAD_WINDOW_MS) {
    reportOutageNow();
    return;
  }
  try {
    deps.storage?.setItem(CHUNK_RELOAD_KEY, String(deps.now()));
  } catch {
    // Depo kapalıysa (gizli pencere) yine de bir kez yenilenir; döngü korumasız kalır ama
    // ikinci hata aynı sayfada tekrar bu işleyiciye düşer ve kesinti katmanı açılır.
  }
  event.preventDefault();
  deps.reload();
}
